import { render, staticRenderFns } from "./AdminFieldWrapper.vue?vue&type=template&id=702dcde5&scoped=true&"
import script from "./AdminFieldWrapper.vue?vue&type=script&lang=js&"
export * from "./AdminFieldWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AdminFieldWrapper.vue?vue&type=style&index=0&id=702dcde5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702dcde5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VInput})
